<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 20px;padding-bottom: 10px">
      <el-form @keyup.enter.native="getTableList" :model="form" class="com-search-box" ref="form" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="出版物名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item label="出版物编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->

          <!-- <el-col :span="6">
            <el-form-item label="出版社 :" prop="publisher">
              <el-input v-model="form.publisher" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="6">
            <el-form-item  class="el-form-state" label="作者 :" prop="author">
              <el-input v-model="form.author" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <!-- <el-row type="flex">
          <el-button style="margin-right: 20px" @click="addBook" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;新增出版物
          </el-button>

          <el-upload ref="bookImport" :show-file-list="false" action="/singleMuseum/book/bsBookInfo/export" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="uploadData">
            <el-button class="el-primary-border">
              <svg-icon icon-class="add" />&nbsp;导入
            </el-button>
          </el-upload>
        </el-row> -->
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="出版物名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="publisher" label="出版社" min-width="10%" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="bookNo" label="出版物编号" min-width="7%"></el-table-column>
          <el-table-column prop="bookType" label="期刊分类" min-width="7%">
            <template slot-scope="scope">{{ scope.row.bookType | filterBookType(that) }}</template>
          </el-table-column> -->
          <el-table-column prop="zhaungzhen" label="装帧" min-width="7%"></el-table-column>
          <el-table-column prop="price" label="价格" min-width="7%"></el-table-column>

          <el-table-column prop="author" label="作者" min-width="7%"></el-table-column>
          <!-- <el-table-column prop="bookNumber" label="书号" min-width="7%"></el-table-column> -->
          <!-- <el-table-column prop="remark" label="备注" min-width="10%"></el-table-column> -->

          <!-- <el-table-column prop="publisher" label="出版社" min-width="7%"></el-table-column> -->
          <el-table-column prop="total" label="册数" min-width="7%"></el-table-column>
          <el-table-column prop="remain" label="剩余数" min-width="7%"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="borrowBook(scope.row.id)">领取</a>
              <a class="m-btn mr-10" v-if="scope.row.attachment" @click="download(scope.row)">下载</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog title="新增出版物" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="110px" :rules="rules">
        <el-form-item label="出版物名称 :" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="出版物编号 :" prop="bookNo">
          <el-input v-model="addForm.bookNo" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="书号 :" prop="bookNumber">
          <el-input v-model="addForm.bookNumber" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="出版物分类 :" prop="bookType">
          <el-select v-model="addForm.bookType" placeholder="请输入">
            <el-option v-for="item in bookTypeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="出版社 :" prop="publisher">
          <el-input v-model="addForm.publisher" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="作者 :" prop="author">
          <el-input v-model="addForm.author" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="册数 :" prop="total">
          <el-input type="number" v-model="addForm.total" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="装帧 :" prop="zhaungzhen">
          <el-input v-model="addForm.zhaungzhen" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="价格 :" prop="price">
          <el-input v-model="addForm.price" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="出版时间 :" prop="publishTime">
          <el-date-picker v-model="addForm.publishTime" format="yyyy-MM-dd HH:ss:mm" value-format="yyyy-MM-dd HH:ss:mm" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="架位 :" prop="jiawei">
          <el-input v-model="addForm.jiawei" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="入库时间 :" prop="gourusj">
          <el-date-picker v-model="addForm.gourusj" format="yyyy-MM-dd  HH:ss:mm" value-format="yyyy-MM-dd  HH:ss:mm"  type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="状态 :" prop="status">
          <el-select v-model="addForm.status" placeholder="请输入">
            <el-option v-for="item in bookStatus" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="备注 :" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="addForm.remark"></el-input>
        </el-form-item>

        <el-form-item label="附件 :" prop="attachment">
          <cmpUploadProgress ref="cmpUploadProgress" :callFun="uploadCallback" :accept="`.doc, .docx, .pdf, .xls, .xlsx`"></cmpUploadProgress>
        </el-form-item> -->

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="领取出版物" :visible.sync="dialogVisible1" width="30%">
      <el-form class="g-form-grid" ref="borrowForm" :model="borrowForm" label-width="90px" :rules="borrowRules">
        <el-form-item label="领取数量 :" prop="num">
          <el-input v-model.number="borrowForm.num" placeholder="请输入"></el-input>
        </el-form-item>

        <!-- <el-form-item label="借阅天数 :" prop="day">
          <el-input v-model="borrowForm.day" placeholder="请输入"></el-input>
        </el-form-item> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">取 消</el-button>
        <el-button type="primary" @click="handleBorrow()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress' // 上传组件
import axios from 'axios'
export default {
  components: {
    cmpUploadProgress
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        author: '',
        type: 3
      },
      addForm: {
        name: '',
        publisher: '',
        author: '',
        total: '',
        zhuangzhen: '',
        price: '',
        publishTime: '',
        jiawei: '',
        gourusj: '',
        status: 2,
        type: 3
      },
      borrowForm: {
        num: '',
        day: 1,
        type: 3
      },
      rules: {
        name: [
          { required: true, message: '出版物名称不能为空', trigger: 'blur' },
        ],

        publisher: [
          { required: true, message: '出版社不能为空', trigger: 'blur' },
        ],

        author: [
          { required: true, message: '作者不能为空', trigger: 'blur' },
        ],

        total: [
          { required: true, message: '出版物数量不能为空', trigger: 'blur' },
        ],
      },

      borrowRules: {
        num: [
          { required: true, message: '请输入领取数量', trigger: 'blur' },
        ],
      },
      borrowId: '',
      listLoading: true,
      tableData: [],
      bookTypeList: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      uploadData: {
        file: '',
        type: 3
      },
      dialogVisible: false,
      dialogVisible1: false
    }
  },

  filters: {
    filterBookType(type, that) {
      let obj = that.bookTypeList.filter(item => {
        return item.dictCode == type
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.tableData = []
      this.$api.book.getBookPageList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    
    getTableList(){
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.get('/collectDict/getSelectDataByKey', {
        key: 'book_type'
      }).then(res => {
        if (res.success) {
          this.bookTypeList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // 详情
    borrowBook(id) {
      
      this.borrowId = id
      this.dialogVisible1 = true

      // this.$router.push({
      //   path: '/approve/start-approve',
      //   query:{typeId:'166028969254617351412153905462104'}
      // })
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.addForm.attachment = fileStr
    },

    //下载出版物
    download(obj) {
      axios({
        method: 'get',
        url: '/singleMuseum/book/bsBookInfo/download',
        responseType: 'blob', //二进制流
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        params: {
          attachmentId: obj.attachment
        }
      }).then(res => {
        if (res) {
          let fileName = obj.name;
          const blob = new Blob([res.data]);
          if (res.headers) {
            let contentDisposition = res.headers['content-disposition'];
            if (contentDisposition) {
              fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8");
            }
            if (fileName) {
              fileName = fileName.split('.')[0]
            }
          }
          const linkNode = document.createElement('a');
          linkNode.setAttribute('download', fileName + '.xls');
          linkNode.style.display = 'none';
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click();  //模拟在按钮上的一次鼠标单击

          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }
      })
    },


    restList(formName) {
      this.$refs[formName].resetFields();
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    addBook() {
      this.dialogVisible = true
    },

    handleClose() {
      this.$refs['addForm'].resetFields()
      // this.$refs['cmpUploadProgress'].viewFileList = []
      this.dialogVisible = false
    },

    handleClose1() {
      this.$refs['borrowForm'].resetFields()
      this.dialogVisible1 = false
    },

    beforeAvatarUpload(file) {
      let formData = new FormData()
      formData.append('file', file.raw)
      this.uploadData.file = formData
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('导入成功')
        this.initData()
      } else {
        this.$message.error(res.message)
      }
    },

    //领取出版物
    handleBorrow() {
      this.$refs['borrowForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.borrowBook({
            ...this.borrowForm,
            id: this.borrowId
          }).then(res => {
            if (res.success) {
              this.$message.success('领取成功')
              this.handleClose1()
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    handleSubmit() {
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          this.addForm.bookNo = '111'
          this.$api.book.addBookInfo({
            ...this.addForm,
          }).then(res => {
            if (res.success) {
              this.$message.success('新增成功')
              this.handleClose()
              this.initData()
            }else{
              this.$message.success(res.message)

            }
          })
        }
      })
    }

  },

  mounted() {
    this.getDropdownValue()
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.btn-wrapper {
  display: flex;
  justify-content: right;
  margin: 10px 0;
}

.el-form-state{
  /deep/ .el-form-item__label{
    width: 60px !important;
  }

  /deep/ .el-form-item__content{
    margin-left: 60px !important;
  }
}

</style>